import { IconButton, parseHtml } from '@healthhub/react-ui';
import DOMPurify from 'dompurify';
import { Link } from 'react-router';

import { FilledAnnouncementIcon, OutlinedCloseIcon, OutlinedRightIcon } from '@shared/assets-icon';
import { MaxWidthContainer } from '@shared/components';
import { INBOX_NOTIFICATIONS_PATH, INBOX_PUBLIC_NOTIFICATIONS_PATH } from '@shared/constants/paths';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';
import { useGetImportantNoticesQuery } from '@shared/services/importantNotices';
import { layoutSelector } from '@shared/stores/layout/layoutSelector';
import { layoutAction } from '@shared/stores/layout/layoutSlice';
import { useAppDispatch, useAppSelector } from '@shared/stores/rootTypes';
import { formatLineToHtmlBreak } from '@shared/utils/string';

const ImportantNotices = () => {
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useAppDispatch();
  const { showGlobalImportantNotices } = useAppSelector(layoutSelector);

  const { data = [] } = useGetImportantNoticesQuery({
    NoticeType: 'Notices',
    Source: 'Web',
  });

  const showViewAllButton = data.length > 0;

  const onClickClose = () => {
    dispatch(layoutAction.setShowGlobalImportantNotices(false));
  };

  if (data.length === 0 || showGlobalImportantNotices === false) {
    return null;
  }

  return (
    <div className="h-26.5 flex shrink-0 justify-center bg-functional-haze px-3 py-4 drop-shadow-important-notices lg:h-auto lg:px-18">
      <MaxWidthContainer className="flex flex-col justify-between gap-3 lg:flex-row">
        <div className="flex justify-between">
          <div className="flex gap-2 lg:items-center">
            <FilledAnnouncementIcon className="size-6px shrink-0" />
            <div className="line-clamp-2" lang="en">
              {parseHtml(formatLineToHtmlBreak(DOMPurify.sanitize(data[0].Message, { FORBID_TAGS: ['img'] })))}
            </div>
          </div>
          <IconButton
            aria-label="Close important notices"
            className="self-start lg:hidden"
            icon={<OutlinedCloseIcon className="size-6 [&_path]:fill-black" />}
            onClick={onClickClose}
          />
        </div>
        {!!showViewAllButton && (
          <Link
            className="ml-8 flex shrink-0 items-center gap-1 self-start hover:underline lg:ml-0 lg:self-center"
            to={isAuthenticated ? INBOX_NOTIFICATIONS_PATH : INBOX_PUBLIC_NOTIFICATIONS_PATH}
          >
            <span className="text-sm" lang="en">
              View all ({data.length})
            </span>
            <OutlinedRightIcon className="[&_path]:stroke-primary-blue-grey-4" />
          </Link>
        )}
      </MaxWidthContainer>
    </div>
  );
};

export default ImportantNotices;
